



















































import Vue from 'vue'
import Component from 'vue-class-component'
import DisplaySkills from '@app/componentlib/src/views/components/DisplaySkills.vue'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { ga } from '@app/componentlib/src/application/analytics'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import InfoToolTip from '@app/componentlib/src/views/components/InfoToolTip.vue'

@Component<CvAdjustExperiences>({
  props: {
    items: Object,
    profileLink: String,
    validExperiences: Object
  },
  components: {
    DisplaySkills,
    VPopover,
    InfoToolTip
  },
  directives: {
    VTooltip,
    VClosePopover
  }
})

export default class CvAdjustExperiences extends Vue {
  /**
   * Props variables
   */
  items: object[] | undefined
  validExperiences: string[] | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }
  get profileLink (): string | undefined {
    return AppModule.portalSettings.profileLink  + '#experience'
  }

  /**
   * Methods
   */
  goToProfile () {
    ga.event({
      action: 'Go to profile - header',
      category: 'CV Tool',
      label: 'Experiences - header'
    })
  }
}
